import { ICustomer } from "./Reviews.types";

export const fakeCustomers: ICustomer[] = [
  {
    customerName: "Leszek Zugaj",
    companyName: "",
    opinion:
      "Z panią Kingą Dolczewską współpracuję już prawie 9 lat. Kawał czasu. Zawsze sumienna i dyspozycyjna. Polecam!",
  },
  {
    customerName: "Magdalena Unolt (Prezes Zarządu)",
    companyName: "UNOLT PARTNER EDUKACYJNY",
    opinion:
      "Od wielu lat współpracuję z P. Kingą Dolczewską w zakresie korekty tekstów medycznych publikacji. Praca Pani Kingi cechuje się wysoką starannością i elastycznym podejściem czasowym. Gorąco polecam.",
  },
  {
    customerName: "Szymon Machniewski",
    companyName: "Agencja Kreatywna Sofista",
    opinion:
      "Zaangażowana, rzetelna, terminowa, zawsze doskonały kontakt. Polecam",
  },
];
